import { createContext } from "react";
import { DataRow } from "../DataRow";
import { DataId } from "../DataId";

/** The value passed into the `DataListRowContext` provider. */
export interface DataListContextValue {

  /** The row. */
  readonly row: DataRow<object> | null;

  /** The row DataId. */
  readonly id: DataId;

  /** Indicates whether the row has child content. */
  readonly hasChildContent?: boolean;
}

/**
 * A context which represents a single list row.
 */
export const DataListRowContext = createContext<DataListContextValue>({
  row: null,
  id: 0,
  hasChildContent: false,
});
